import { useSyncExternalStore } from 'react';
import type { TheaterSession, TheaterState } from './TheaterSession';

/** Re-renders when the session emits; returns the current state snapshot. */
export function useSessionState(session: TheaterSession | null): TheaterState | null {
  return useSyncExternalStore(
    (cb) => (session ? session.subscribe(cb) : () => {}),
    () => (session ? session.state : null),
    () => (session ? session.state : null),
  );
}
